// extracted by mini-css-extract-plugin
module.exports = {"descriptionHeader":"GenericTextAttributeRenderer_descriptionHeader__TjEOG"};